//Function to check if the user modules
export const checkUserModules = (moduleCode, modules) => {
    let module = modules.map(element => element.module_code).indexOf(moduleCode);
    return module
}